// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"554df28a2e2f66dd9762","655":"94a15bf89a6ee3766cd5"}[chunkId] + ".js";
};